import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { getEpisodes, getEpisodesReset } from './redux/actions';
import Loading from '../../common/components/Loading';
import Episodes from './Episodes';
import Episode from './Episode';

class Show extends Component {
  componentDidMount() {
    const { dispatch, match, episodesLoaded } = this.props;

    if (!episodesLoaded) {
      dispatch(getEpisodes(match.params.showId));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(getEpisodesReset());
  }
  render() {
    const { match, episodesLoaded } = this.props;

    if (!episodesLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={Episodes} />
        <Route exact path={`${match.path}/:episodeId`} component={Episode} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => ({
  episodesLoaded: state.subscription.tv.episodes.get('loaded'),
});

export default connect(mapStateToProps)(Show);



// WEBPACK FOOTER //
// ./src/subscription/tv/Show.js